import React from 'react';

const Test = () => {
  return <>test</>;
};

export default Test;
